import { includes, isArray } from 'lodash';

const EMPTY_RESULT = { count: 0, categorySelect: {} };

/**
 * Counts how many active filter options match the current searchParams.
 * Returns { count, categorySelect } suitable for setCountFilter().
 */
const computeFilterCount = (
	unitFilters,
	searchType,
	searchParams,
	searchLocation,
) => {
	if (!searchLocation) return EMPTY_RESULT;

	const filters = unitFilters[searchType];
	if (!filters) return EMPTY_RESULT;

	let count = 0;
	const categorySelect = {};

	Object.keys(filters).forEach((filterName) => {
		const filter = filters[filterName];
		if (!filter.options) return;

		filter.options.forEach((option) => {
			const paramValue = searchParams[option.name];
			const isChecked =
				paramValue === `${option.value}` ||
				(isArray(paramValue) &&
					includes(paramValue, `${option.value}`));

			if (!isChecked) return;

			if (filter.multiple) {
				count += 1;
			} else if (!categorySelect[option.name]) {
				count += 1;
				categorySelect[option.name] = true;
			}
		});
	});

	return { count, categorySelect };
};

export default computeFilterCount;
